import { Button, Tooltip } from 'antd'
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../auth'

const STORAGE_KEY = 'showCandidatePhone'

export function phoneVisible() {
    return localStorage.getItem(STORAGE_KEY) === 'true'
}

export function CandidatePhoneToggle() {
    const { t } = useTranslation()

    const { showCandidatePhone, setShowCandidatePhone } = useAuth()

    return (
        <Tooltip title={showCandidatePhone ? t('Hide phone number') : t('Show phone number')}>
            <Button
                type="text"
                onClick={() => {
                    localStorage.setItem(STORAGE_KEY, `${!showCandidatePhone}`)
                    setShowCandidatePhone(!showCandidatePhone)
                }}
                icon={showCandidatePhone ? <EyeInvisibleOutlined /> : <EyeOutlined />}
            />
        </Tooltip>
    )
}
